import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { useEffect, useState } from "react";
import { url } from "../../src/utils/Constants";
import "./Analytics.css";

function Analytics() {
 const [data, setData] = useState([]);

 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();

 // ✅ FIX 1: Safe extraction
 const loggedInEnterpriseId = activeAccount?.idTokenClaims?.enterpriseID || "";

 // ================= POST =================
 const lkmPagesAnalytics = async () => {
  try {
   // ✅ FIX 2: Skip API if no enterprise_id
   if (!loggedInEnterpriseId) return;

   await axios.post(
    `${url}/analytics`,
    { enterprise_id: loggedInEnterpriseId },
    {
     headers: {
      Authorization: sessionStorage.getItem("token"),
      "Content-Type": "application/json",
     },
    },
   );

   getAnalytics();
  } catch (error) {
   console.error("POST analytics error:", error);
  }
 };

 // ================= GET =================
 const getAnalytics = async () => {
  try {
   const response = await axios.get(`${url}/analytics`, {
    headers: {
     Authorization: sessionStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   });

   // ✅ FIX 3: Safe fallback
   setData(Array.isArray(response?.data) ? response.data : []);
  } catch (err) {
   console.error("GET analytics error:", err);
   setData([]); // ✅ FIX 4
  }
 };

 // ================= COMPUTATION =================

 // ✅ FIX 5: Safe reduce instead of map
 const totalUserViews = Array.isArray(data)
  ? data.reduce((acc, view) => acc + (Number(view?.totalUniqueUsers) || 0), 0)
  : 0;

 const totalViews = Array.isArray(data)
  ? data.reduce(
     (acc, view) =>
      acc +
      (Array.isArray(view?.Data)
       ? view.Data.reduce((sum, item) => sum + (Number(item?.totalSum) || 0), 0)
       : 0),
     0,
    )
  : 0;

 useEffect(() => {
  lkmPagesAnalytics();
 }, [loggedInEnterpriseId]); // ✅ FIX 6

 return (
  <>
   <span className="analytics-span">
    <img src="/images/Home/medium-eye-new.png" className="eye-icon" alt="eye" />
    Total Views: {totalViews} &nbsp; | &nbsp; Unique Views: {totalUserViews}
   </span>
  </>
 );
}

export default Analytics;
